import { atom } from 'recoil';
import { MemberItem } from '@store/firebase/user/getUsers';

/**
 * 전역 멤버 목록 캐시 atom
 * - 앱 마운트 시 1회 Firestore 조회 후 저장
 * - mention 모듈, plain text @멘션, 답글 참가자 매핑 등에서 공용 사용
 * - null: 아직 로드 전 / []: 빈 결과 / MemberItem[]: 로드 완료
 */
export const membersCacheState = atom<MemberItem[] | null>({
  key: 'membersCacheState',
  default: null,
});
